<template>
  <b-card>
    <b-row>
      <b-col md="6">
        <h3>{{ $route.name }}</h3>

        <!-- breadcrumb -->
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <!-- end breadcrumb -->
      </b-col>

      <b-col md="6">
        <b-button variant="primary" :to="'cash-in/create'" class="float-right btn-custom"
          ><font-awesome-icon icon="plus"
        /></b-button>
      </b-col>
    </b-row>

   <form v-on:submit.prevent="doFilter">
      <b-row class="mt-3 mb-5">
        <b-col md="4">
          <div>
            <date-picker
              v-model="tableFilter.date"
              type="date"
              customQueryParamName="search"
              placeholder="Search By Date"
            ></date-picker>
          </div>
        </b-col>
        <b-col md="3">
          <!-- button filter -->
          <button type="submit" class="ml-2 btn btn-primary float-right" id="btn-search">
            <font-awesome-icon icon="search" />Filter
          </button>
          <!-- end button -->

          <!-- button clear filter -->
          <button
            @click="clearFilter()"
            class="ml-0 btn btn-outline-primary float-right"
            id="btn-search"
          >
            <font-awesome-icon icon="times-circle" /> Clear Filter
          </button>
          <!-- end button -->
        </b-col>

        <b-col></b-col>
      </b-row>
    </form>
      <paginated-table
      ref="dataTable"
      :can-edit="false"
      :can-delete="true"
      :can-approve="false"
      :can-reject="false"
      :can-show="true"
      :can-edit-modal="false"
      :can-paid="false"
      :data-url="apiUrl.cashIn"
      :data-key="dataKey"
      :data-columns="columns"
      :data-params="['search_customer', 'start_date', 'cash_date', 'status', 'search']"
    ></paginated-table>

  </b-card>
</template>

<script>
import PaginatedTable from '../../../components/PaginatedTable.vue'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  name: 'cashin-index',
  components: { PaginatedTable, DatePicker },
  data () {
    return {
      isLoading: false,
      loadFilter: false,
      buttonPrev: false,
      buttonNext: true,
      // rows: 0,
      currentPage: 1,
      pageSize: null ,
      page: 1,
      perPage: 10,
      index: 0,
      dataKey: 'cash',
       columns: [
        {
          key: 'cashNumber',
          label: 'No Transaction',
        },
        {
          key: 'cashDate',
          label: 'Date',
        },
        {
          key: 'transactionJournalCode',
          label: 'Acc Code',
        },
        {
          key: 'transactionJournalAccount',
          label: 'Account Name',
        },
        {
          key: 'transactionNote',
          label: 'Description',
          class: 'position-relative'
        },
        {
          key: 'transactionDebit',
          label: 'Debit',
        },
        {
          key: 'transactionCredit',
          label: 'Credit',
        },
        {
          key: 'actionCashIn',
          label: '',
        },
      ],
      apiUrl : {
        cashIn: window.AppConfig.apiUrl + 'cash?cash_type=CI'
      },
       tableFilter: {
        search_customer: this.$route.params.search_customer,
        cash_date: this.$route.params.cash_date,
        due_date: this.$route.params.due_date,
        status: this.$route.params.status,
        date: null,
        tanggal: null,
      },
      model:{
        cashIn: [],
        paginate: 1,
      },
      filter: {
        cash_date: null,
      },
       canShowRoutePath: {
        type: String,
        required: false,
        default: '',
      },
    }
  },
  watch: {
    
  },
  mounted () {
    
  },

  methods: {
     doFilter() {
      // eslint-disable-next-line no-self-assign
      this.tableFilter.cash_date =
        this.tableFilter.date !== null
          ? this.$moment(this.tableFilter.date).format('YYYY-MM-DD')
          : null;
      this.tableFilter.due_date =
        this.tableFilter.tanggal !== null
          ? this.$moment(this.tableFilter.tanggal).format('YYYY-MM-DD')
          : null;
      this.$refs.dataTable.doFilter(this.tableFilter);
    },

    clearFilter() {
      this.tableFilter.tanggal = null;
      this.tableFilter.date = null;
      this.$refs.dataTable.doFilter(this.tableFilter);
    },

    doDeleteData(uuid){
      this.$swal({
          title: 'Are you sure?',
          text: 'You will not be able to recover this data!',
          icon: "warning",
          buttons: true,
          dangerMode: true,
          buttonsStyling: false,
        }).then(result => {
          if (result) {
            this.$http.delete(window.AppConfig.apiUrl + 'cash' + '/' + uuid).then(response => {
              this.$store.dispatch('notification/success', 'Successfully deleted.')
              this.getJournalData()
            }).catch(error => {
              this.$store.dispatch('notification/error', 'Failed To Delete Data.')
              window.consoleLog(error)
            })
          }
        })
    },

   formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('DD MMM YYYY');
      } else {
        return '-';
      }
    },

  },
}
</script>

<style lang="css">

</style>